import { render } from "./CustomSelection.vue?vue&type=template&id=8b9fc8fe"
import script from "./CustomSelection.vue?vue&type=script&lang=js"
export * from "./CustomSelection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__